import request from "@/utils/request";
const { ElMessage } = require("element-plus");
const { ElMessageBox } = require("element-plus");

export default {
  name: "ClassInfo",
  data() {
    return {
      loading: true,
      judge: false,
      dialogVisible: false,
      importDialogVisible: false,
      search: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      multipleSelection: [],
      reminders: {
        todayCheckin: 0,
        todayCheckout: 0,
        tomorrowCheckout: 0,
        weekCheckout: 0
      },
      // 班级预设颜色（与房态颜色区分：房态偏亮偏饱和，班级偏深偏沉稳）
      classColorOptions: [
        { label: '深玫红', color: '#C4141B' },
        { label: '墨绿', color: '#2E7D32' },
        { label: '金色', color: '#D4A017' },
        { label: '酒红', color: '#8B0000' },
        { label: '靛蓝', color: '#1A237E' },
        { label: '赤陶', color: '#C2185B' },
        { label: '青铜', color: '#6D4C41' },
        { label: '暗蓝灰', color: '#37474F' }
      ],
      form: {
        className: "",
        startDate: "",
        endDate: "",
        colorTag: "#C4141B"
      },
      rules: {
        className: [
          { required: true, message: "请输入班级名称", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择入住日期", trigger: "change" },
        ],
        endDate: [
          { required: true, message: "请选择离校日期", trigger: "change" },
        ]
      },
      importFile: null
    };
  },
  created() {
    this.load();
    this.loadReminders();
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    async load() {
      request.get("/classInfo/page", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          search: this.search
        }
      }).then((res) => {
        this.tableData = res.data.records || res.data || [];
        this.total = res.data.total || 0;
        this.loading = false;
      });
    },
    loadReminders() {
      request.get("/classInfo/reminders").then((res) => {
        if (res.code === "0") {
          this.reminders = res.data;
        }
      });
    },
    reset() {
      this.search = "";
      this.currentPage = 1;
      this.load();
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form = {
          className: "",
          startDate: "",
          endDate: "",
          colorTag: "#C4141B"
        };
        this.judge = false;
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.judge === false) {
            request.post("/classInfo/add", this.form).then((res) => {
              if (res.code === "0") {
                ElMessage({ message: "新增成功", type: "success" });
                this.load();
                this.loadReminders();
                this.dialogVisible = false;
              } else {
                ElMessage({ message: res.msg, type: "error" });
              }
            });
          } else {
            request.put("/classInfo/update", this.form).then((res) => {
              if (res.code === "0") {
                ElMessage({ message: "修改成功", type: "success" });
                this.load();
                this.loadReminders();
                this.dialogVisible = false;
              } else {
                ElMessage({ message: res.msg, type: "error" });
              }
            });
          }
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    handleEdit(row) {
      this.judge = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form = JSON.parse(JSON.stringify(row));
      });
    },
    handleDelete(id) {
      request.delete("/classInfo/delete/" + id).then((res) => {
        if (res.code === "0") {
          ElMessage({ message: "删除成功", type: "success" });
          this.load();
          this.loadReminders();
        } else {
          ElMessage({ message: res.msg, type: "error" });
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBatchDelete(row) {
      ElMessageBox.confirm("确认结业该班级？（将同步退房清理学员数据）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        request.post("/classInfo/batchDeleteStudents", { ids: [row.id] }).then((res) => {
          if (res.code === "0") {
            ElMessage({ message: res.msg || "结业成功", type: "success" });
            this.load();
            this.loadReminders();
          } else {
            ElMessage({ message: res.msg, type: "error" });
          }
        }).catch(() => {
          ElMessage({ message: "操作失败", type: "error" });
        });
      });
    },
    handleBatchDeleteSelection() {
      if (this.multipleSelection.length === 0) {
        ElMessage({ message: "请先选择要结业的班级", type: "warning" });
        return;
      }
      ElMessageBox.confirm("确认批量结业选中的班级？（将同步退房清理学员数据）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const ids = this.multipleSelection.map(item => item.id);
        request.post("/classInfo/batchDeleteStudents", { ids }).then((res) => {
          if (res.code === "0") {
            ElMessage({ message: res.msg || "批量结业成功", type: "success" });
            this.load();
            this.loadReminders();
          } else {
            ElMessage({ message: res.msg, type: "error" });
          }
        }).catch(() => {
          ElMessage({ message: "操作失败", type: "error" });
        });
      });
    },
    handleImport() {
      this.importDialogVisible = true;
      this.importFile = null;
    },
    handleFileChange(file) {
      this.importFile = file.raw;
    },
    cancelImport() {
      this.importFile = null;
      this.importDialogVisible = false;
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },
    confirmImport() {
      if (!this.importFile) {
        ElMessage({ message: "请选择文件", type: "warning" });
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importFile);
      request.post("/classInfo/import", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then((res) => {
        if (res.code === "0") {
          ElMessage({ message: "导入成功", type: "success" });
          this.cancelImport();
          this.load();
        } else {
          ElMessage({ message: res.msg, type: "error" });
        }
      });
    },
    downloadTemplate() {
      const template = [
        ['班级名称', '入住日期', '离校日期', '颜色标记'],
        ['Java培训班', '2026-06-01', '2026-07-01', '#C4141B'],
        ['Python培训班', '2026-06-15', '2026-07-15', '#2E7D32']
      ];
      this.exportToCsv(template, '班级导入模板.csv');
    },
    exportToCsv(data, filename) {
      let csv = data.map(row => row.join(',')).join('\n');
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      ElMessage({ message: '模板下载成功', type: 'success' });
    },
    handleExport() {
      if (this.multipleSelection.length === 0) {
        window.open(request.defaults.baseURL + "/classInfo/exportAll");
      } else if (this.multipleSelection.length === 1) {
        window.open(request.defaults.baseURL + "/classInfo/export/" + this.multipleSelection[0].classId);
      } else {
        ElMessage({ message: "请选择一个班级进行导出，或不选导出全部", type: "warning" });
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
};
